export default __webpack_public_path__ + "static/media/andres1.04ecda94.jpg";